import ExcelJS from "exceljs";
import jsPDF from 'jspdf';
import autoTable from "jspdf-autotable";

export const ExportEmployee = ({ employeeData, corporationDetails = [] }) => {
    const getCorporationName = (item) => {
        const corp = corporationDetails.find(
            (c) => c.corporationId === (item.corporationId || item.organizationId)
        );
        return corp?.corporationName || item.corporationName || "-";
    };

    const exportToExcel = async () => {

        // Create a new workbook and add a worksheet
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("Employee");

        // Define styles
        const boldFont = { bold: true };

        // Get current date and time
        const currentDate = new Date();
        const formattedDate = `${currentDate.getDate()}-${currentDate.getMonth() + 1}-${currentDate.getFullYear()}`;
        const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
        const downloadDateTime = `Employee Details Generated on: ${formattedDate}, ${formattedTime}`;

        // Add the downloadDateTime to the worksheet
        worksheet.addRow(["", "", downloadDateTime, ""]);
        worksheet.mergeCells(1, 2, 1, 13);
        worksheet.getCell(1, 2).value = downloadDateTime;
        worksheet.getCell(1, 2).font = boldFont;
        worksheet.getCell(1, 2).alignment = { horizontal: "center" };

        // Add "Employee Details" header
        worksheet.addRow(["", "", "Employee Details", ""]);
        worksheet.mergeCells(2, 2, 2, 13);
        worksheet.getCell(2, 2).value = "Employee Details";
        worksheet.getCell(2, 2).font = boldFont;
        worksheet.getCell(2, 2).alignment = { horizontal: "center" };

        // Define table headers
        const tableHeaderRow = worksheet.addRow([
            "S.No",
            "Employee ID",
            "Employee Name",
            "Corporation",
            "Operation",
            "Designation",
            "Zone",
            "Circle",
            "Transfer Station",
            "Gender",
            "Contact No",
            "Shift",
            "Status",
        ]);
        tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
            cell.font = boldFont;
            cell.alignment = { horizontal: "center" };
            if (colNumber >= 1 && colNumber <= 13) {
                cell.fill = {
                    type: "pattern",
                    pattern: "solid",
                    fgColor: { argb: "F6B1B1" },
                    bgColor: { argb: "FFFFFFFF" },
                };
            }
        });

        // Add data rows
        employeeData.forEach((item, index) => {
            worksheet.addRow([
                index + 1,
                item.employeeId || "N/A",
                item.employeeName || "N/A",
                getCorporationName(item),
                item.operationName || "N/A",
                item.designationName || "N/A",
                item.zoneName || "N/A",
                item.circleName || "N/A",
                item.transferStationName || "N/A",
                item.gender || "N/A",
                item.contactNo || "N/A",
                item.shiftName || "N/A",
                item.isActive ? "Active" : "InActive",
            ]).eachCell({ includeEmpty: true }, (cell) => {
                cell.alignment = { horizontal: "center" };
            });
        });

        // Set column widths
        worksheet.columns = [
            { width: 5 },   // S.No
            { width: 20 },  // Employee ID
            { width: 30 },  // Employee Name
            { width: 25 },  // Corporation
            { width: 25 },  // Operation
            { width: 25 },  // Designation
            { width: 20 },  // Zone
            { width: 20 },  // Circle
            { width: 30 },  // Transfer Station
            { width: 15 },  // Gender
            { width: 15 },  // Contact No
            { width: 20 },  // Shift
            { width: 12 },  // Status
        ];

        // Save the workbook to a file
        try {
            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const url = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = "Employee.xlsx";
            a.click();
            URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Error generating Excel file:", error);
        }
    };
    const exportToPDF = () => {
        const doc = new jsPDF("landscape", "mm", "a4"); // Landscape orientation
        const currentDate = new Date();
        const formattedDate = `${currentDate.getFullYear()}-${currentDate.getMonth() + 1}-${currentDate.getDate()}`;
        const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
        const downloadDateTime = `Employee Details Generated on: ${formattedDate} ${formattedTime}`;
        doc.setFont("helvetica", "bold");  // Set font to Helvetica and style to bold
        doc.setFontSize(16);
        doc.text("Employee Details", 14, 20);  // Title text at (x, y) coordinates
        doc.setFontSize(12);
        doc.text(downloadDateTime, 14, 30);
        autoTable(doc, {
            startY: 35,
            head: [
                [
                    "S.No",
                    "Employee ID",
                    "Employee Name",
                    "Corporation",
                    "Operation",
                    "Designation",
                    "Zone",
                    "Circle",
                    "Transfer Station",
                    "Gender",
                    "Contact No",
                    "Shift",
                    "Status",
                ],
            ],
            body: employeeData.map((item, index) => [
                index + 1,
                item.employeeId || "N/A",
                item.employeeName || "N/A",
                getCorporationName(item),
                item.operationName || "N/A",
                item.designationName || "N/A",
                item.zoneName || "N/A",
                item.circleName || "N/A",
                item.transferStationName || "N/A",
                item.gender || "N/A",
                item.contactNo || "N/A",
                item.shiftName || "N/A",
                item.isActive ? "Active" : "InActive",
            ]),
            headStyles: { fillColor: "red" },
            styles: {
                fontSize: 7,
                halign: "center",
            },
            columnStyles: {
                0: { cellWidth: 10 },
                1: { cellWidth: 18 },
                2: { cellWidth: 28 },
                3: { cellWidth: 22 },
                4: { cellWidth: 20 },
                5: { cellWidth: 20 },
                6: { cellWidth: 18 },
                7: { cellWidth: 18 },
                8: { cellWidth: 30 },
                9: { cellWidth: 12 },
                10: { cellWidth: 18 },
                11: { cellWidth: 15 },
                12: { cellWidth: 12 },
            },
            margin: { top: 20 },
            didParseCell: (data) => {
                if (data.row.raw) {
                    // Reduce padding for compact display
                    data.cell.styles.cellPadding = 2;
                }
            },
        });
        doc.save("EmployeeDetails.pdf");
    };
    return (
        <>
            <button
                className="button-container"
                onClick={exportToExcel}
            >
                <i className="fa-solid fa-file-excel me-1 icon-container"></i>
                Excel
            </button>
            <button
                className="button-container"
                onClick={exportToPDF}
            >
                <i className="fa-solid fa-file-pdf me-1 icon-container"></i>
                PDF
            </button>
        </>
    )
}